<template>
  <div class="container_article_right">
    <p class="font_1_400_Kreadon_Regular color_violet">
      {{ authors.length > 1 ? "Авторы" : "Автор" }}
    </p>
    <div class="box_autor_article">
      <div
        class="autor_article_first"
        v-for="(author, index) in authors.slice(0, 1)"
        :key="index"
      >
        <img class="img_autor_article" :src="author.image" :alt="author.name" />
      </div>
      <div v-if="authors.length > 1">
        <div
          class="autor_article_first m_autor_article"
          v-for="(author, index) in authors.slice(1, 2)"
          :key="index"
        >
          <img
            class="img_autor_article"
            :src="author.image"
            :alt="author.name"
          />
        </div>
      </div>

      <div
        ref="box_all_autor_article"
        class="box_all_autor_article"
        :style="{ bottom: authors.length === 1 ? '-125%' : '-200%' }"
      >
        <div
          class="all_autor_article"
          v-for="(author, index) in authors"
          :key="'list-' + index"
        >
          <img
            class="img_autor_article_small"
            :src="author.image"
            :alt="author.name"
          />
          <div class="box_text_all_autor_article">
            <p class="font_1_400_Kreadon_Regular">{{ author.name }}</p>
            <p class="font_1_400_Kreadon_Regular color_violet">
              {{ author.position }}
            </p>
          </div>
        </div>
      </div>
      <button @click="toggleModal" class="button_open_autor_article">
        <img
          :src="isModalOpen ? closeImageSrc : openImageSrc"
          class="img_button_open_autor_article"
          alt="стрелка"
        />
      </button>
    </div>
    <p class="title_services_design">Подпишись на наши соцсети</p>
    <p class="font_1_400_Kreadon_Regular color_violet">
      Мы отправляем полезные материалы, которые помогут вам в работе. Мы
      отправляем полезные материалы, которые помогут вам в работе
    </p>
    <div class="container_button_networks_articles">
      <div class="box_button_networks_articles">
        <button class="button_v1">Telegram</button>
      </div>
      <div class="box_button_networks_articles">
        <a href="https://www.youtube.com/@mti-dev" target="_blank" class="button_v1">Youtube</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    authors: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      isModalOpen: false,
      openImageSrc: require("@/assets/elements/arrow_bottom_white.svg"),
      closeImageSrc: require("@/assets/elements/arrow_top_white.svg"),
    };
  },
  methods: {
    toggleModal() {
      this.isModalOpen = !this.isModalOpen;
      this.$refs.box_all_autor_article.classList.toggle("active");
    },
    closeModal() {
      this.isModalOpen = false;
      this.$refs.box_all_autor_article.classList.remove("active");
    },
  },
};
</script>
